import type React from "react";
import { useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { AI_AGENT_MEETING_ROOT } from "app/pages/sales-intelligence/constants/routes";
import { useGetThreads } from "app/pages/sales-intelligence/modules/ai-agent/queries/useGetThreads";
import AIAgentTrackingService from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/trackingService";
import { HistoryDropdown } from "app/pages/sales-intelligence/pages/ai-agent/components/HistoryDropdown/HistoryDropdown";
import {
    StyledActionButton,
    StyledActionsContainer,
} from "app/pages/sales-intelligence/pages/ai-agent/containers/ActionsContainer/styles";
import { proNavigator } from "single-spa/react-app/ProNavigator";

type Props = {
    variant?: "chatPage" | "gatePage";
    topOffset?: number;
};

export const ActionsContainer: React.FC<Props> = ({ variant = "chatPage", topOffset = 0 }) => {
    const {
        params: { id },
    } = useCurrentStateAndParams<{ id?: string }>();
    const [isHistoryDDOpened, setIsHistoryDDOpened] = useState(false);

    const { data, isPending } = useGetThreads();

    const handleNewChatClick = () => {
        AIAgentTrackingService.meeting.trackStartNewChat();
        void proNavigator.go(AI_AGENT_MEETING_ROOT);
    };

    const handleOpenHistoryDD = () => {
        AIAgentTrackingService.meeting.trackOpenHistory();
        setIsHistoryDDOpened(true);
    };

    return (
        <StyledActionsContainer
            variant={variant}
            topOffset={topOffset}
        >
            <Tooltip
                content={translate("si.pages.ai_agent.actions.history.tooltip")}
                placement="right"
            >
                <div>
                    <StyledActionButton
                        iconName="history"
                        iconColor={colorsPalettes.carbon[300]}
                        type="flat"
                        isActive={isHistoryDDOpened}
                        onClick={handleOpenHistoryDD}
                    />
                </div>
            </Tooltip>
            {variant === "chatPage" ? (
                <Tooltip
                    content={translate("si.pages.ai_agent.actions.new_chat.tooltip")}
                    placement="right"
                >
                    <div>
                        <StyledActionButton
                            iconName="add"
                            iconColor={colorsPalettes.carbon[300]}
                            type="flat"
                            onClick={handleNewChatClick}
                        />
                    </div>
                </Tooltip>
            ) : null}
            <HistoryDropdown
                isOpen={isHistoryDDOpened}
                setIsOpen={setIsHistoryDDOpened}
                data={data}
                currentThreadId={id}
                isLoading={isPending}
            />
        </StyledActionsContainer>
    );
};
